export default [
  'Thailand',
  'Japan',
  'Singapore',
  'Nepal',
  'Malaysia',
  'Canada',
  'Australia',
  'Cambodia',
  'Sri,Lanka',
  'Germany',
  'Finland',
  'United,Arab,Emirates',
  'Philippines',
  'India',
  'Italy',
  'Sweden',
  'Spain',
  'Belgium',
  'Egypt',
  'Lebanon',
  'Iraq',
  'Oman',
  'Afghanistan',
  'Bahrain',
  'Kuwait',
  'Algeria',
  'Croatia',
  'Switzerland',
  'Austria',
  'Israel',
  'Pakistan',
  'Brazil',
  'Georgia',
  'Greece',
  'North,Macedonia',
  'Norway',
  'Romania',
  'Estonia',
  'San,Marino',
  'Belarus',
  'Iceland',
  'Lithuania',
  'Mexico',
  'New,Zealand',
  'Nigeria',
  'Ireland',
  'Luxembourg',
  'Monaco',
  'Qatar',
  'Ecuador',
  'Azerbaijan',
  'Armenia',
  'Dominican,Republic',
  'Indonesia',
  'Portugal',
  'Andorra',
  'Latvia',
  'Morocco',
  'Saudi,Arabia',
  'Senegal',
  'Argentina',
  'Chile',
  'Jordan',
  'Ukraine',
  'Hungary',
  'Liechtenstein',
  'Poland',
  'Tunisia',
  'Bosnia,and,Herzegovina',
  'Slovenia',
  'South,Africa',
  'Bhutan',
  'Cameroon',
  'Colombia',
  'Costa,Rica',
  'Peru',
  'Serbia',
  'Slovakia',
  'Togo',
  'Malta',
  'Martinique',
  'Bulgaria',
  'Maldives',
  'Bangladesh',
  'Paraguay',
  'Albania',
  'Cyprus',
  'Brunei',
  'US',
  'Burkina,Faso',
  'Holy,See',
  'Mongolia',
  'Panama',
  'China',
  'Iran',
  'Korea,,South',
  'France',
  'Cruise,Ship',
  'Denmark',
  'Czechia',
  'Taiwan*',
  'Vietnam',
  'Russia',
  'Moldova',
  'Bolivia',
  'Honduras',
  'United,Kingdom',
  'Congo,(Kinshasa)',
  "Cote,d'Ivoire",
  'Jamaica',
  'Turkey',
  'Cuba',
  'Guyana',
  'Kazakhstan',
  'Ethiopia',
  'Sudan',
  'Guinea',
  'Kenya',
  'Antigua,and,Barbuda',
  'Uruguay',
  'Ghana',
  'Namibia',
  'Seychelles',
  'Trinidad,and,Tobago',
  'Venezuela',
  'Eswatini',
  'Gabon',
  'Guatemala',
  'Mauritania',
  'Rwanda',
  'Saint,Lucia',
  'Saint,Vincent,and,the,Grenadines',
  'Suriname',
  'Kosovo',
  'Central,African,Republic',
  'Congo,(Brazzaville)',
  'Equatorial,Guinea',
  'Uzbekistan',
  'Netherlands',
  'Benin',
  'Liberia',
  'Somalia',
  'Tanzania',
  'Barbados',
  'Montenegro',
  'Kyrgyzstan',
  'Mauritius',
  'Zambia',
  'Djibouti',
  'Gambia,,The',
  'Bahamas,,The',
  'Chad',
  'El,Salvador',
  'Fiji',
  'Nicaragua',
  'Madagascar',
  'Haiti',
  'Angola',
  'Cabo,Verde',
  'Niger',
  'Papua,New,Guinea',
  'Zimbabwe',
  'Cape,Verde',
  'East,Timor',
  'Eritrea',
  'Uganda'
]
